<template>
    <!-- <button type="button" class=" btn-primary1" @click="this.show = true">
        Confirmer
    </button> -->
  
    <!-- Modal -->
    <div class="modal-backdrop-container" v-if="show">
        <div class="modal-msg-confirm modal-max-size" role="dialog">
            <div class="custom-modal" role="document">
                <div class="custom-modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5">{{ title }}</h1>
                        <button type="button" class="btn-close" @click="cancel"></button>
                    </div>
                    <div class="modal-body">
                        <div class="msg-confirm">
                            <svg width="170" height="170" viewBox="0 0 170 170" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.3023 148.75C18.0037 148.75 16.8231 148.427 15.7606 147.78C14.6981 147.133 13.8717 146.276 13.2814 145.208C12.6912 144.141 12.3677 142.989 12.311 141.752C12.2544 140.514 12.5778 139.306 13.2814 138.125L78.8023 24.7917C79.5106 23.6111 80.4267 22.7257 81.5506 22.1354C82.6745 21.5451 83.8244 21.25 85.0002 21.25C86.176 21.25 87.3282 21.5451 88.4569 22.1354C89.5855 22.7257 90.4992 23.6111 91.1981 24.7917L156.719 138.125C157.427 139.306 157.753 140.517 157.696 141.759C157.64 143.001 157.314 144.151 156.719 145.208C156.124 146.266 155.298 147.123 154.24 147.78C153.182 148.436 152.001 148.759 150.698 148.75H19.3023ZM31.521 134.583H138.479L85.0002 42.5L31.521 134.583ZM85.0002 127.5C87.0071 127.5 88.6906 126.82 90.0506 125.46C91.4106 124.1 92.0882 122.419 92.0835 120.417C92.0788 118.414 91.3988 116.733 90.0435 115.373C88.6882 114.013 87.0071 113.333 85.0002 113.333C82.9932 113.333 81.3121 114.013 79.9569 115.373C78.6016 116.733 77.9216 118.414 77.9169 120.417C77.9121 122.419 78.5921 124.102 79.9569 125.467C81.3216 126.832 83.0027 127.509 85.0002 127.5ZM85.0002 106.25C87.0071 106.25 88.6906 105.57 90.0506 104.21C91.4106 102.85 92.0882 101.169 92.0835 99.1667V77.9167C92.0835 75.9097 91.4035 74.2286 90.0435 72.8733C88.6835 71.5181 87.0024 70.8381 85.0002 70.8333C82.998 70.8286 81.3169 71.5086 79.9569 72.8733C78.5969 74.2381 77.9169 75.9192 77.9169 77.9167V99.1667C77.9169 101.174 78.5969 102.857 79.9569 104.217C81.3169 105.577 82.998 106.255 85.0002 106.25Z" fill="#FBBC00"/>
                            </svg>
                            <h4>{{ description }}</h4>
                            <h5 class="note">{{ notes }}</h5>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-around">
                        <button type="button" class="btn-primary1" @click="confirm">{{ textConfirmationButton }}</button>
                        <button type="button" class="btn-confirm1" @click="cancel">{{ textCancelButton }}</button>
                    </div>
                </div>
                <!-- <div class="modal-backdrop"></div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnnulationPopUp',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Annulez votre rendez-vous'
        },
        description: {
            type: String,
            default: 'Êtes-vous sûr de vouloir annuler votre rendez-vous?'
        },
        textConfirmationButton: {
            type: String,
            default: 'Confirmer'
        },
        textCancelButton: {
            type: String,
            default: 'Annuler'
        },
        notes: {
            type: String,
            default: ''
        }
    },
    emits: ['confirm', 'cancel', 'update:show'],
    methods: {
        // Handle logic in parent component for usability
        cancel() {
            this.$emit('update:show', false);
            // this.$emit('cancel')
        },
        confirm() {
            this.$emit('confirm');
            this.$emit('update:show', false);
        }
    }
}
</script>

<style scoped>
.modal-backdrop-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  color: black;
  justify-content: center;
}

.modal-msg-confirm {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}

.custom-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 90%;
  /* max-width: 500px; */
  z-index: 9999;
}

.custom-modal-content {
  padding: 1.5rem;
}
.note {
    color: rgb(208, 0, 0);
}
.modal-max-size {
    max-width: 40rem;
}
</style>